import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const FilesWrapper = styled.div`
  width: 250px;
  margin: auto;
`;

export const FileItemPadding = styled.div`
  padding-top: 100%;
`;

export const FileImg = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;

  ${({ opacity }) =>
    opacity &&
    `
    opacity: ${opacity};
  `}
  ${({ blur }) =>
    blur &&
    `
    filter: blur(${blur}px);
  `}
`;

export const ResizedFileImg = styled.img.attrs(({ dimenParamToChange, ratio }) => {
  const width = dimenParamToChange === 'width' ? `calc(100% * ${ratio})` : '100%';
  const height = dimenParamToChange === 'height' ? `calc(100% * ${ratio})` : '100%';

  return {
    style: {
      width,
      height,
    },
  };
})`
  position: absolute;
  top: 0;
`;

export const ImgDeleteOverlay = styled.div`
  position: absolute;
  top: 0;
  display: none;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.grey500};
  opacity: 0.6;
  cursor: pointer;
`;

export const ImgDeleteIcon = styled.span`
  display: none;
  cursor: pointer;
  &:before {
    content: '\\e91f';
    font-family: 'Icomoon';
    position: absolute;
    top: 7px;
    right: 7px;
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const FileItemWrapper = styled.div`
  position: relative;

  &:hover {
    ${ImgDeleteOverlay} {
      display: block;
    }
    ${ImgDeleteIcon} {
      display: block;
    }
  }
`;

export const ImgPreview = styled.img``;

export const Btn = styled.input`
  display: none;
`;

export const LabelWrapper = styled.div`
  text-align: center;
`;

export const Label = styled(typography.BodyTextOneRegularTypography)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  margin: 0;
  padding: 12px 0;
  color: ${({ theme }) => theme.colors.black};
  border: 1px dashed ${({ theme }) => theme.colors.grey005};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;

  &:before {
    content: '\\e949';
    font-family: 'Icomoon';
    margin-inline-end: 5px;
  }
`;
